import { object, string } from "yup"
import email from "@/core/validation/email"

export default object({
  firstName: string().required("Required"),
  lastName: string().required("Required"),
  email,
})
